export default {
  'formandstep-form.basic.title': 'Basic form',
  'formandstep-form.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'formandstep-form.email.required': 'Please enter your email!',
  'formandstep-form.email.wrong-format': 'The email address is in the wrong format!',
  'formandstep-form.userName.required': 'Please enter your userName!',
  'formandstep-form.password.required': 'Please enter your password!',
  'formandstep-form.password.twice': 'The passwords entered twice do not match!',
  'formandstep-form.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'formandstep-form.strength.strong': 'Strength: strong',
  'formandstep-form.strength.medium': 'Strength: medium',
  'formandstep-form.strength.short': 'Strength: too short',
  'formandstep-form.confirm-password.required': 'Please confirm your password!',
  'formandstep-form.phone-number.required': 'Please enter your phone number!',
  'formandstep-form.phone-number.wrong-format': 'Malformed phone number!',
  'formandstep-form.verification-code.required': 'Please enter the verification code!',
  'formandstep-form.title.required': 'Please enter a title',
  'formandstep-form.date.required': 'Please select the start and end date',
  'formandstep-form.goal.required': 'Please enter a description of the goal',
  'formandstep-form.standard.required': 'Please enter a metric',

  'formandstep-form.form.get-captcha': 'Get Captcha',
  'formandstep-form.captcha.second': 'sec',
  'formandstep-form.form.optional': ' (optional) ',
  'formandstep-form.form.submit': 'Submit',
  'formandstep-form.form.save': 'Save',
  'formandstep-form.email.placeholder': 'Email',
  'formandstep-form.password.placeholder': 'Password',
  'formandstep-form.confirm-password.placeholder': 'Confirm password',
  'formandstep-form.phone-number.placeholder': 'Phone number',
  'formandstep-form.verification-code.placeholder': 'Verification code',
  'formandstep-form.title.label': 'Title',
  'formandstep-form.title.placeholder': 'Give the target a name',
  'formandstep-form.date.label': 'Start and end date',
  'formandstep-form.placeholder.start': 'Start date',
  'formandstep-form.placeholder.end': 'End date',
  'formandstep-form.goal.label': 'Goal description',
  'formandstep-form.goal.placeholder': 'Please enter your work goals',
  'formandstep-form.standard.label': 'Metrics',
  'formandstep-form.standard.placeholder': 'Please enter a metric',
  'formandstep-form.client.label': 'Client',
  'formandstep-form.label.tooltip': 'Target service object',
  'formandstep-form.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'formandstep-form.invites.label': 'Inviting critics',
  'formandstep-form.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'formandstep-form.weight.label': 'Weight',
  'formandstep-form.weight.placeholder': 'Please enter weight',
  'formandstep-form.public.label': 'Target disclosure',
  'formandstep-form.label.help': 'Customers and invitees are shared by default',
  'formandstep-form.radio.public': 'Public',
  'formandstep-form.radio.partially-public': 'Partially public',
  'formandstep-form.radio.private': 'Private',
  'formandstep-form.publicUsers.placeholder': 'Open to',
  'formandstep-form.option.A': 'Colleague A',
  'formandstep-form.option.B': 'Colleague B',
  'formandstep-form.option.C': 'Colleague C',
};
